import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import User from '../components/User'
import Cards from '../components/Cards'
import ChangeLanguageWidget from '../components/ChangeLanguageWidget';
import * as pageActions from '../actions/PageActions'
import * as cardsActions from '../actions/CardsActions'
import * as userActions from '../actions/UserActions';
import {sessionService} from 'redux-react-session';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';

import moment from 'moment'
moment.locale('fi');

class App extends Component {

    componentWillMount() {
        sessionService.loadSession()
            .then(currentSession => {
              console.log('sessionService.loadSession() succesful', currentSession);
              if (currentSession.sessionId) {
                this.props.userActions.getUserBySessionId(currentSession.sessionId)
                    .then(user => {
                        if (user) {
                            this.props.cardsActions.getCards(user.isAdmin ? '' : user.companyId);
                        }
                    })
                    .catch(error => {
                      console.log('Failed to get user', error);
                      sessionService.saveSession({sessionId: undefined}).then(() => {
                        this.props.userActions.navigateToLogin()
                      });
                    });
              } else {
                this.props.userActions.navigateToLogin();
              }
            })
            .catch(err => {
                console.log('sessionService.loadSession() failed', err);
                this.props.userActions.navigateToLogin()
            })
    }

    render() {
        const {user, cards, session, currentLanguage, translate} = this.props;
        const {navigateToPasswordChangePage, changeLanguage} = this.props.userActions;
        const {getCards, searchCards, saveCard, saveCardTemporarily, addCard, editCard, editCardTimePeriod, deleteCard} = this.props.cardsActions;
        const logout = () => {
            this.props.userActions.logout().then(() => {
                this.props.cardsActions.clearPage();
            });
        };
        const translations = translate(Object.keys(this.props.translations).map((translation) => translation));

        if (user.login !== '') {
            return (
                <div className='container-fluid cards-block'>
                    <User user={user} logout={logout}
                          navigateToPasswordChangePage={navigateToPasswordChangePage}
                          translations={translations}
                          />
                    <hr/>

                    <Cards card={cards.card} cards={cards.cards} saveCard={saveCard}
                           saveCardTemporarily={saveCardTemporarily} addCard={addCard}
                           editCard={editCard} editCardTimePeriod={editCardTimePeriod}
                           deleteCard={deleteCard} getCards={getCards} searchCards={searchCards}
                           fetching={cards.fetching} action={cards.action} user={user} session={session}
                           translations={translations}
                           />

                    <ChangeLanguageWidget currentLanguage={currentLanguage} changeLanguage={changeLanguage}/>
                </div>
            )
        } else {
            return <div/>
        }
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        page: state.page,
        cards: state.cards,
        session: state.session,
        translations: state.locale.translations,
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code
    }
}

function mapDispatchToProps(dispatch) {
    return {
        pageActions: bindActionCreators(pageActions, dispatch),
        cardsActions: bindActionCreators(cardsActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/containers/App.js